

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"20"}, rest), [h('path', {"fill":"#262626","d":"M15.572 8.69 2.97.302C1.895-.414.44.365.44 1.651v16.754c0 1.306 1.454 2.065 2.529 1.348l12.602-8.387c.948-.611.948-2.044 0-2.676Z"}, [])]);
};

        